const Home: React.FC = () => {
  return <div />
};

export default Home;
